import React from 'react';
import { Flex, Heading, useColorModeValue } from '@chakra-ui/react';
import previewProjectsData from './Data/PreviewProjectsData';
import AnimatedPage from './Other/AnimatedPage';
import ProjectCardV2 from './ProjectCardV2';

const ProjectsPage = () => {
  const underlineColor = useColorModeValue(
    'rgb(64,64,64,0.6)',
    'rgb(255,255,255,0.6)'
  );

  return (
    <AnimatedPage>
      <Flex
        minH={'66vh'}
        mt={'2rem'}
        direction={'column'}
        alignItems={'center'}
      >
        <Heading
          textAlign={['center', 'center', 'center', 'start', 'start', 'start']}
          size={'2xl'}
          w={'100%'}
          borderBottom={`1px solid ${underlineColor}`}
          pb={'15px'}
        >
          Side Projects
        </Heading>
        <Flex
          justifyContent={[
            null,
            null,
            null,
            'space-evenly',
            'space-evenly',
            'space-evenly',
          ]}
          alignItems={['center', 'center', 'center', null, null, null]}
          direction={['column', 'column', 'column', 'row', 'row', 'row']}
          wrap={'wrap'}
          mt={'1rem'}
          w={'100%'}
        >
          {previewProjectsData.map((project, index) => {
            return (
              // <ProjectCard
              //   key={index}
              //   src={project.src}
              //   title={project.title}
              //   tags={project.tags}
              //   description={project.description}
              //   id={project.id}
              // />
              <ProjectCardV2
                key={index}
                id={project.id}
                description={project.description}
                src={project.src}
                title={project.title}
                techIcons={project.techIcons}
              />
            );
          })}
        </Flex>
      </Flex>
    </AnimatedPage>
  );
};

export default ProjectsPage;
